import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-deactive-confirm",
    templateUrl: "./deactive-confirm.component.html",
    standalone: false
})
export class DeactiveConfirmComponent implements OnInit {
  constructor(
    public modal: NgbActiveModal,
    private translateService: TranslateService
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }

  ngOnInit() {}

  leave() {
    this.modal.close(true);
    
  }

  stay() {
    this.modal.close(false);
  }
}
